import React from "react";
import LegalSearchBlock from "../components/LegalSearchBlock";
import { useStatusBar } from "../hooks/useStatusBar";

function LegalSearch() {
  const statusBar = useStatusBar();

  const handleSearch = async () => {
    await statusBar.withLoading(
      "Searching legal documents...",
      async () => {
        // Simulate API call
        await new Promise((resolve) => setTimeout(resolve, 2000));
        return { results: 15 };
      },
      "Found 15 legal documents",
      "Search failed. Please try again."
    );
  };

  return (
    <div className="px-6 py-6 space-y-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold text-white mb-2">Legal Search</h1>
        <p className="text-slate-300">
          Search through legal documents and case law
        </p>
      </div>

      <div className="mb-6">
        <button
          onClick={handleSearch}
          className="bg-command-light-blue hover:bg-command-light-blue/80 text-white px-4 py-2 rounded-md transition-colors"
        >
          Demo: Search with Status Bar
        </button>
      </div>

      <LegalSearchBlock />
    </div>
  );
}

export default LegalSearch;
